<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>
        <subNav></subNav>
        <div class="pressReleases">
            <div class="wrap">
                <div class="title">PRESS RELEASES</div>
                <div class="press-content">
                    <!-- <div data-qmod-tool="fullnews" data-qmod-params='{"symbol":"MSFT"}' class="qtool"></div> -->
                    <!-- <div data-qmod-tool="fullnews" data-qmod-params="{}" class="qtool"></div> -->
                    <!--<div data-qmod-tool="fullnews" data-qmod-params='{"symbol":"MSFT", "videonews":false,"showVideos":false}' class="qtool"></div> -->
                    <div data-qmod-tool="fullnews" data-qmod-params='{"symbol":"MMV", "videonews":false,"showVideos":false, "src":"prn"}' class="qtool"></div>
                </div>
                <div class="press-content" style="display: none;">
                    <div>
                        <div class="key">
                            <div class="word">Keyword Search</div>
                            <div>
                                <el-row>
                                    <el-col :span="5">
                                        <el-input
                                            v-model="input"
                                            placeholder="请输入内容"
                                        ></el-input>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-button
                                            type="info"
                                            class="Search"
                                            @click="change"
                                            
                                            >Search</el-button
                                        >
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="news">
                            <!-- <div>
                                <div class="caption">News Category</div>
                                <div>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-input
                                                v-model="input"
                                                placeholder="请输入内容"
                                            ></el-input>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div> -->
                            <div class="year">
                                <div class="caption">Year</div>
                                <div>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-date-picker
                                                v-model="value3"
                                                type="year"
                                                value-format="yyyy"
                                                placeholder="选择年"
                                            >
                                            </el-date-picker>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                            <div class="filter">
                                <el-button type="info" @click="change"
                                    >Filter</el-button
                                >
                            </div>
                        </div>
                    </div>
                    <div class="main-content">
                        <div class="sub-caption">
                            <span class="date">Date</span>
                            <span class="details">Title</span>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(item, index) in releasesList" :key="index">
                            <span class="time">{{
                                item.datetime.split(" ")[0]
                            }}</span>
                            <span class="headline"
                                ><span>{{ item.title }}</span></span
                            >
                            <span class="printer-pdf">
                                <!-- <img
                                    src="@/assets/investor-Relation/printer.png"
                                    alt=""
                                /> -->
                                <a :href="item.files_path[0]">
                                    <img
                                        src="@/assets/investor-Relation/pdf.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) == 'pdf'
                                        "
                                    />
                                    <img
                                        src="@/assets/investor-Relation/rar.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) ==
                                                'rar' ||
                                            getFile(item.files_path[0]) == 'zip'
                                        "
                                    />
                                    <img
                                        src="@/assets/investor-Relation/rtf.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) == 'rtf'
                                        "
                                    />
                                    <img
                                        src="@/assets/investor-Relation/word.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) ==
                                            'word'
                                        "
                                    />
                                    <img
                                        src="@/assets/investor-Relation/xlsx.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) ==
                                            'xlsx'
                                        "
                                    />
                                     <img
                                        src="@/assets/investor-Relation/img.png"
                                        alt=""
                                        v-if="
                                            getFile(item.files_path[0]) == 'jpg' ||
                                            getFile(item.files_path[0]) == 'png'
                                        "
                                    />
                                </a>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "pressReleases",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
            input: "",
            value3: "",
            releasesList: [],
            loading: false,
        };
    },
    created() {
        this.getReleasesList({ types: "releases", keywords: this.input});
    },
    methods: {
        getReleasesList(types) {
            this.loading = true;
            this.$http.getWebReleases(types).then((res) => {
                this.releasesList = res;
                this.loading = false;
            });
        },
        change() {
            var yearData = {};
            if (this.value3 !== "" && this.value3) {
                yearData = { year: this.value3 };
            }
            this.getReleasesList({
                types: "releases",
                keywords: this.input,
                ...yearData,
            });
        },
        getFile(url){
            var site=url.lastIndexOf("\.");
            return url.substring(site+1,url.length)
        }
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.pressReleases {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .press-content {
        border: 1px solid #dcdcdc;
        padding: 30px;
        .key {
            margin-top: 10px;
            .word {
                margin-bottom: 10px;
            }
            .Search {
                margin-left: 20px;
            }
        }
        .news {
            margin-top: 45px;
            display: flex;
            .caption {
                margin-bottom: 10px;
            }
            // .year {
            //     margin-left: 20px;
            // }
            .filter {
                position: relative;
                top: 30px;
                left: 30px;
            }
        }
        .sub-caption {
            width: 1140px;
            height: 30px;
            line-height: 30px;
            color: #f2f2f2;
            font-size: 15px;
            background: #283254;
            margin-top: 45px;
            .date {
                width: 145px;
                display: inline-block;
                text-indent: 20px;
            }
        }
        ul {
            margin-bottom: 40px;
            li {
                height: 110px;
                border-bottom: 1px solid #e9e9e9;
                .time {
                    display: inline-block;
                    width: 145px;
                    color: #333333;
                    font-size: 14px;
                    text-indent: 20px;
                    height: 110px;
                    line-height: 110px;
                }
                .headline {
                    color: #333333;
                    font-size: 16px;
                    display: inline-block;
                    width: 75%;
                    height: 110px;
                    font-family: 'Lucida Bright';
                }
                .printer-pdf {
                    float: right;
                    position: relative;
                    top: 35px;
                    img {
                        margin-right: 30px;
                        width: 22px;
                        height: 25px;
                    }
                }
            }
        }
    }
}
.pressReleases .press-content ul li .headline span:hover {
    border-bottom: 2px solid #a5a5a5;
    cursor: pointer;
}
</style>